<template>
  <svg
    width="24"
    height="27"
    viewBox="0 0 24 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.79064 0L1.71252 6.79641V10.2663H3.20501V7.79035H8.87689V1.44926H20.7945V10.2666H22.2873V0.000575299L7.79064 0Z"
      fill="currentcolor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.20251 20.8528H20.7949V25.5507L3.20251 25.5339V20.8528ZM15.633 13.2576H19.8534V14.263H16.8744V15.5718H19.4807V16.584H16.8744V19.009H15.633L15.633 13.2576ZM9.56737 13.2576H11.8604C13.4357 13.2576 14.5787 14.4556 14.6064 16.0732C14.634 17.5575 13.747 19.0089 12.0482 19.0089H9.56737V13.2576ZM4.14733 13.2576H6.76297C7.81899 13.2576 8.66271 14.0386 8.66271 15.1214C8.66271 16.1559 7.87608 16.9213 6.76297 16.9213H5.38867V19.0093H4.14733V13.2576ZM0 11.4133V20.8521H1.71226V26.9804L22.2876 27L22.2877 20.8525H24V11.4131L0 11.4133Z"
      fill="currentcolor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.3881 14.2539V15.9452H6.56577C7.22201 15.9452 7.55299 15.621 7.57357 15.0864C7.59376 14.4917 7.06136 14.2539 6.56577 14.2539H5.3881Z"
      fill="currentcolor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.7723 18.0302H11.7986C12.8459 18.0302 13.3441 17.1535 13.3423 16.0736C13.3375 15.0127 12.8941 14.254 11.691 14.254H10.7723L10.7723 18.0302Z"
      fill="currentcolor"
    />
  </svg>
</template>
